exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-avatar{width:50px;height:50px;margin-top:2px;border-radius:50%}.rounded-circle{width:25px;height:25px;border-radius:50%}.navbar-brand{color:#007bff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f240549","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/navigation/navigation.vue
// module id = 44
// module chunks = 0